import React, { useContext, useEffect, useState } from 'react'
import ComponentFormPortfolioFields from "../forms/ComponentFormPortfolioFields"
import * as lookup from "../../../static/lookup.json"
import * as porfolioCodes from "../../../static/portfolioToCode.json"
import * as keywordMapping from "../../../static/nvestKeyMapping.json"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from '../context/journeyContext'
import { ErrorContext } from "../context/errorContext"
import { PageContext } from '../context/pageContext'
import { SectionContext } from "../context/sectionContext"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import { getValueFromLookup } from "../services/helperFunctions"
import { getAllInputQuotations, saveApplication, generateBI } from "../../services/apiservice"
import { errorToastr } from '../../services/error-handler'

export default function PortfolioGroup(props) {
    //console.log("comppropssss",props,props.journeyIdFromStrapi);
    const [conditionState, setConditionState] = useContext(ConditionContext)
    const [journeyState, setJourneyState] = useContext(JourneyContext)
    const [errorState, setErrorState] = useContext(ErrorContext)
    const [pageState, setPageState] = useContext(PageContext)
    const [sectionState, setSectionState] = useContext(SectionContext)
    const [portfolioLength, setPortfolioLength] = useState(0)
    const [portfolioComponentsToShow, setPortfolioComponentsToShow] = useState(props.data.filter(fund => ["portfolioF2","portfolioF4"].includes(fund?.PFCheckbox?.formControlKey)))
    const [totalError, setTotalError] = useState("")
    const [showLocalError, setShowLocalError] = useState(false)

    console.log(props.channel);

    const handlePrevious = () => {
        setErrorState({})
        props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
        setSectionState({
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
        })

        //handeling context change
        if (pageState.pageId === props.pageId) {
            pageState.pageData.map((element, index) => {
                if (
                    element.sectionId === props.sections[props.currentSectionIndex - 1]?.sectionId // setting section context from page context
                ) {
                    setSectionState(prev => {
                        return {
                            ...prev,
                            sectionId: element.sectionId,
                            sectionData: element.sectionData,
                        }
                    })
                }
            })
        }
    }

    const handleProceed = () => {
        let isValidSection = Object.keys(errorState).every(element => {
            if (Array.isArray(errorState[element])) {
                return errorState[element].every(subElement => {
                    return subElement === ""
                })
            } else {
                if (element === "errorFromBI") {
                    return true
                } else {
                    return errorState[element] === ""
                }

            }
        })
        if (!sectionState.sectionData["totalFundValue"]) {
            errorToastr("Please select funds")
            if (!isValidSection) {
                props.setShowError(true)
            }
            return
        }
        if (sectionState.sectionData["totalFundValue"] && parseInt(sectionState.sectionData["totalFundValue"]) !== 100) {
            if (parseInt(sectionState.sectionData["totalFundValue"]) < 100) {
                setTotalError("Total allocation percentage cannot be less than 100%")
                setShowLocalError(true)
            } else {
                setTotalError("Total allocation percentage cannot be greater than 100%")
                setShowLocalError(true)
            }
            if (!isValidSection) {
                props.setShowError(true)
            }
            return
        }
        if((journeyState.journeyIdFromStrapi === "titaniumPlusJourney" || journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney") && sectionState.sectionData?.portfolioManagementOptions === "AFR"){
            let count = 0
            props.data.map((portfolioInput) => {
                console.log(portfolioInput)
                let valueToCheck = portfolioInput.PFCheckbox.formControlKey
                if(sectionState.sectionData[valueToCheck]){
                    count = count + 1
                }
            })
            if(count === 1){
                errorToastr("Please select minimum 2 funds")
                return
            }
        }
        if (isValidSection) {
            if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
                let foundSection = pageState.pageData.find(
                    element => element.sectionId === sectionState.sectionId
                )

                if (foundSection) {
                    let newPageData = pageState.pageData.filter(
                        element => element.sectionId !== foundSection.sectionId
                    )
                    setPageState(prev => {
                        return {
                            ...prev,
                            pageData: newPageData, //newPageData has all sections except founded section
                        }
                    })
                    foundSection = {}
                }

                setPageState(prev => {
                    return {
                        ...prev,
                        pageData: [...prev.pageData, sectionState], // adding new section
                    }
                })
            } else {
                setPageState(prev => {
                    return {
                        ...prev,
                        pageId: props.pages[props.currentPageIndex].pageId,
                        pageData: [...prev.pageData, sectionState],
                    }
                })
            }

            let pageData = pageState.pageData.filter(
                element => element.sectionId !== sectionState.sectionId
            )
            let journeyData = journeyState.journeyData.filter(
                element => element.pageId !== props.pages[props.currentPageIndex].pageId
            )

            let LoadPaylod = [
                ...journeyData,
                {
                    pageId: props.pages[props.currentPageIndex].pageId,
                    pageData: [...pageData, sectionState],
                },
            ]

            let sendPayload = {
                applicationData: LoadPaylod,
                journeyData: {
                    _id: journeyState.journeyId,
                    lastPage: props.currentPageIndex,
                    lastSection: props.currentSectionIndex,
                    applicationNo: journeyState.applicationNo,
                    illustrationNumber: journeyState.illustrationNumber,
                    planOption: journeyState.planOption,
                    journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                    proposalEntryId: journeyState.proposalEntryId,
                    lastPageCode: props.pageId,
                    premium: journeyState.premium,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                },
            }
            saveApplication(sendPayload).then(async res => {
                let payload = {
                    journeyId: journeyState?.journeyId,
                }
                const biApiData = await generateBI(payload)
                if (journeyState?.journeyIdFromStrapi == "insureSmart") {
                    console.log("BICALL", biApiData?.data)
                    if (biApiData.data?.BIJson && biApiData.data?.BIJson2) {
                        let parsedBIJson = JSON.parse(biApiData.data?.BIJson)
                        let parsedBIJson2 = JSON.parse(biApiData.data?.BIJson2)
                        setErrorState(prev => {
                            return {
                                ...prev,
                                ["errorFromBI"]: "",
                            }
                        })
                        setJourneyState(prev => {
                            return {
                                ...prev,
                                insureFundBiKeys: {
                                    "insureFundValue8Perc": String(Math.round(parsedBIJson2?.[parsedBIJson2.length - 1]?.FINAL_FV)),
                                    "insureFundValue4Perc": String(Math.round(parsedBIJson?.[parsedBIJson.length - 1]?.FINAL_FV))
                                }
                            }
                        })
                        props.setCurrentSectionIndex(prev => prev + 1)

                    } else {
                        if (biApiData.data.InputValidationStatus && biApiData.data.InputValidationStatus[0]?.ErrorMessage) {
                            let str = biApiData.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                            // errorToastr(str)
                            setErrorState(prev => {
                                return {
                                    ...prev,
                                    ["errorFromBI"]: str,
                                }
                            })

                        } else {
                            setErrorState(prev => {
                                return {
                                    ...prev,
                                    ["errorFromBI"]: biApiData.data.Message,
                                }
                            })
                            errorToastr(biApiData.data.Message)
                        }
                    }
                } else if (journeyState?.journeyIdFromStrapi == "invest4GJourney") {
                    console.log("BICALL", biApiData?.data)
                    if (biApiData.data?.BIJson && biApiData.data?.BIJson2) {
                        let parsedBIJson = JSON.parse(biApiData.data?.BIJson)
                        let parsedBIJson2 = JSON.parse(biApiData.data?.BIJson2)
                        console.log(parsedBIJson, parsedBIJson2)
                        console.log("YOUR FUND- portfolio",{
                            "invest4GFundValue8Perc": String(Math.round(parsedBIJson2?.[parsedBIJson.length - 1]?.FINAL_FV)),
                            "invest4GFundValue4Perc": String(Math.round(parsedBIJson?.[parsedBIJson2.length - 1]?.FINAL_FV))
                        })
                        setErrorState(prev => {
                            return {
                                ...prev,
                                ["errorFromBI"]: "",
                            }
                        })
                        setJourneyState(prev => {
                            return {
                                ...prev,
                                invest4GFundBiKeys: {
                                    "invest4GFundValue8Perc": String(Math.round(parsedBIJson2?.[parsedBIJson2.length - 1]?.FINAL_FV)),
                                    "invest4GFundValue4Perc": String(Math.round(parsedBIJson?.[parsedBIJson.length - 1]?.FINAL_FV))
                                }
                            }
                        })
                        props.setCurrentSectionIndex(prev => prev + 1)

                    } else {
                        if (biApiData.data.InputValidationStatus && biApiData.data.InputValidationStatus[0]?.ErrorMessage) {
                            let str = biApiData.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                            // errorToastr(str)
                            setErrorState(prev => {
                                return {
                                    ...prev,
                                    ["errorFromBI"]: str,
                                }
                            })

                        } else {
                            setErrorState(prev => {
                                return {
                                    ...prev,
                                    ["errorFromBI"]: biApiData.data.Message,
                                }
                            })
                            errorToastr(biApiData.data.Message)
                        }
                    }
                } else {
                    if (biApiData.data?.BIJson && biApiData.data?.BIJson2) {
                        let parsedBIJson = JSON.parse(biApiData.data?.BIJson)
                        let parsedBIJson2 = JSON.parse(biApiData.data?.BIJson2)
                        console.log(parsedBIJson, parsedBIJson2)
                        setErrorState(prev => {
                            return {
                                ...prev,
                                ["errorFromBI"]: "",
                            }
                        })
                        setJourneyState(prev => {
                            return {
                                ...prev,
                                titaniumBiKeys: {
                                    "projectedFundValue8Perc": String(Math.round(parsedBIJson2?.[parsedBIJson2.length - 1]?.FINAL_FV)),
                                    "projectedFundValue4Perc": String(Math.round(parsedBIJson?.[parsedBIJson.length - 1]?.FINAL_FV))
                                }
                            }
                        })
                        props.setCurrentSectionIndex(prev => prev + 1)

                    } else {
                        if (biApiData.data.InputValidationStatus && biApiData.data.InputValidationStatus[0]?.ErrorMessage) {
                            let str = biApiData.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                            // errorToastr(str)
                            setErrorState(prev => {
                                return {
                                    ...prev,
                                    ["errorFromBI"]: str,
                                }
                            })

                        } else {
                            setErrorState(prev => {
                                return {
                                    ...prev,
                                    ["errorFromBI"]: biApiData.data.Message,
                                }
                            })
                            //errorToastr(biApiData.data.Message)
                        }
                    }
                }
            }).catch(err => {
                console.log(err, "err in portfolio group")
            })
        } else {
            props.setShowError(true)
        }
    }

    useEffect(async () => {
        if (sectionState.sectionData?.["portfolioManagementOptions"]) {
            let payloadForAllInput = {
                ProductId: journeyState.productId,
                Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
                journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                frequency: journeyState.journeyIdFromStrapi === "invest4GJourney" ?  getValueFromLookup("frequencyToAllInputFrequnecyMapper", conditionState["PageInvest4GCalculateFundValue.SectionInvest4GInvestmentDetails.invest4gPremiumFrequency"]) : journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney" ?  getValueFromLookup("frequencyToAllInputFrequnecyMapper", conditionState["PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarPaymentFrequency"]) : getValueFromLookup("frequencyToAllInputFrequnecyMapper", conditionState["PageTitaniumPlusCalculateFundValue.CFSectionInvestmentDetails.CFPaymentFrequency"]),
                fundStrategy: sectionState.sectionData?.["portfolioManagementOptions"]
            }
            let getAllInputResponse = await getAllInputQuotations(payloadForAllInput)
            console.log("getAllInputResponse", getAllInputResponse)
            if (getAllInputResponse.data && getAllInputResponse.data.funds) {
                let funds = getAllInputResponse.data.funds
                if (Array.isArray(funds)) {
                    let temp = JSON.parse(JSON.stringify(props.data))
                    console.log("temp", temp)
                    let newPorfolioOptions = []
                    let toEmptySectionState = {}
                    let toEmptyErrorState = {}
                    let nVestFunds
                    let totalFundPercentage = sectionState.sectionData?.["totalFundValue"]
                    temp.forEach(element => {
                        if(sectionState.sectionData && sectionState.sectionData[element?.["PFCheckbox"]?.formControlKey]){
                            nVestFunds = false
                        }
                        funds.forEach(fund => {
                            if(fund?.["Unified_key"] === porfolioCodes?.[journeyState.journeyIdFromStrapi][element?.["PFCheckbox"]?.formControlKey]){
                                nVestFunds = true
                                newPorfolioOptions.push(element)
                            }
                        })
                        if(!nVestFunds){
                            toEmptySectionState[element?.["PFCheckbox"]?.formControlKey] = false
                            toEmptySectionState[element?.["PFInput"]?.formControlKey] = ""
                            toEmptyErrorState[element?.["PFInput"]?.formControlKey] = ""
                            totalFundPercentage = totalFundPercentage - sectionState.sectionData[element?.["PFInput"]?.formControlKey]
                    }
                    });
                    newPorfolioOptions = newPorfolioOptions.filter(fund => ["portfolioF2","portfolioF4"].includes(fund.PFCheckbox.formControlKey))
                    setPortfolioLength(newPorfolioOptions?.length)

                    setPortfolioComponentsToShow(newPorfolioOptions)
                    let pageId
                    let sectionId
                    if(journeyState.journeyIdFromStrapi === "titaniumPlusJourney"){
                        pageId = "PageTitaniumPlusCalculateFundValue"
                        sectionId = "CFPortfolioManagementOptions"
                    } else if(journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney"){
                        pageId = "PageFutureDollarGiftCityCalculateFundValue"
                        sectionId = "FutureDollarGiftCityPortfolioManangementSection"
                    } else if(journeyState.journeyIdFromStrapi === "invest4GJourney"){
                        pageId = "PageInvest4GCalculateFundValue"
                        sectionId = "Invest4GPortfolioManagementOptions"
                    }
                    let temptoChange = journeyState.journeySteps
                    let tempPageIndexToChange = temptoChange.pages.findIndex(element => element.pageId === pageId)
                    let tempSectionIndexToChange = temptoChange.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                    let tempComponentGroupIndexToChange = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "overallPortFolioOptions")
                    let tempComponentIndexToChange = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.PFCheckbox.formControlKey === "portfolioF7")
                    temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange].PFCheckbox["disabled"] = false

                    let tempComponentIndexToChangeInput = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.PFInput.formControlKey === "portfolioF7text")
                    temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeInput].PFInput["disabled"] = false

                    setSectionState(prev => {
                        return {
                            ...prev,
                            sectionData: {
                                ...prev.sectionData,
                                ...toEmptySectionState,
                                ["totalFundValue"]: totalFundPercentage
                            }
                        }
                    })
                    setErrorState(prev => {
                        return {
                            ...prev,
                            ...toEmptyErrorState
                        }
                    })
                    setJourneyState(prev => {
                        return ({
                          ...prev,
                          journeySteps: temptoChange
                        })
                      })

                } else {
                    // let temp = JSON.parse(JSON.stringify(props.data))
                    // console.log("temp", temp)
                    // let newPorfolioOptions = temp.filter(element => element?.["PFCheckbox"]?.formControlKey === "portfolioF7")
                    // console.log("newPorfolioOptions", newPorfolioOptions)
                    // setPortfolioComponentsToShow(newPorfolioOptions)
                    let pageId
                    let sectionId
                    let toEmptySectionState = {}
                    if(journeyState.journeyIdFromStrapi === "titaniumPlusJourney"){
                        pageId = "PageTitaniumPlusCalculateFundValue"
                        sectionId = "CFPortfolioManagementOptions"
                    } else if(journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney"){
                        pageId = "PageFutureDollarGiftCityCalculateFundValue"
                        sectionId = "FutureDollarGiftCityPortfolioManangementSection"
                    } else if(journeyState.journeyIdFromStrapi === "invest4GJourney"){
                        pageId = "PageInvest4GCalculateFundValue"
                        sectionId = "Invest4GPortfolioManagementOptions"
                    }
                    setPortfolioLength(1)
                    let temptoChange = journeyState.journeySteps
                    let tempPageIndexToChange = temptoChange.pages.findIndex(element => element.pageId === pageId)
                    let tempSectionIndexToChange = temptoChange.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                    let tempComponentGroupIndexToChange = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "overallPortFolioOptions")
                    let tempComponentIndexToChange = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.PFCheckbox.formControlKey === "portfolioF7")
                    temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange].PFCheckbox["disabled"] = true

                    let tempComponentIndexToChangeInput = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.PFInput.formControlKey === "portfolioF7text")
                    temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeInput].PFInput["disabled"] = true

                    let temp = JSON.parse(JSON.stringify(temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components))
                    console.log("temp", temp)
                    let newPorfolioOptions = temp.filter(element => element?.["PFCheckbox"]?.formControlKey === "portfolioF7")
                    props.data.forEach(element => {
                        if (sectionState.sectionData && sectionState.sectionData[element?.["PFCheckbox"]?.formControlKey]) {
                            toEmptySectionState[element?.["PFCheckbox"]?.formControlKey] = false
                            toEmptySectionState[element?.["PFInput"]?.formControlKey] = ""                        }
                    });
                    console.log("newPorfolioOptions", newPorfolioOptions)
                    setPortfolioComponentsToShow(newPorfolioOptions)
                    setSectionState(prev => {
                        return {
                            ...prev,
                            sectionData: {
                                ...prev.sectionData,
                                ...toEmptySectionState,
                                ["portfolioF7"]: true,
                                ["portfolioF7text"]: 100,
                                ["totalFundValue"]: 100
                            },
                        }
                    })
                    setJourneyState(prev => {
                        return ({
                          ...prev,
                          journeySteps: temptoChange
                        })
                      })
                }
            }
        } else {
            let pageId
            let sectionId
            if(journeyState.journeyIdFromStrapi === "titaniumPlusJourney"){
                pageId = "PageTitaniumPlusCalculateFundValue"
                sectionId = "CFPortfolioManagementOptions"
            } else if(journeyState.journeyIdFromStrapi === "FutureDollarGiftCityJourney"){
                pageId = "PageFutureDollarGiftCityCalculateFundValue"
                sectionId = "FutureDollarGiftCityPortfolioManangementSection"
            } else if(journeyState.journeyIdFromStrapi === "invest4GJourney"){
                pageId = "PageInvest4GCalculateFundValue"
                sectionId = "Invest4GPortfolioManagementOptions"
            }
            let temptoChange = journeyState.journeySteps
            let tempPageIndexToChange = temptoChange.pages.findIndex(element => element.pageId === pageId)
            let tempSectionIndexToChange = temptoChange.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
            let tempComponentGroupIndexToChange = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "overallPortFolioOptions")
            let portfolioComp = temptoChange.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components
            portfolioComp = portfolioComp?.filter(fund => ["portfolioF2","portfolioF4"].includes(fund.PFCheckbox.formControlKey))
            setSectionState(prev => {
                return {
                    ...prev,
                    sectionData : {
                        ...prev.sectionData,
                        totalFundValue : prev.sectionData?.["totalFundValue"] || 0
                    }
                }
            })
            setJourneyState(prev => {
                return ({
                  ...prev,
                  journeySteps: temptoChange
                })
            })
            setPortfolioLength(portfolioComp?.length)
            setPortfolioComponentsToShow(portfolioComp)
        }


    }, [sectionState.sectionData?.["portfolioManagementOptions"]])

    const handleReset = () => {
        let toEmptySectionState = {}
        let toEmptyErrorState = {}
        portfolioComponentsToShow.forEach(element => {
            if (sectionState.sectionData && sectionState.sectionData[element?.["PFCheckbox"]?.formControlKey]) {
                toEmptySectionState[element?.["PFCheckbox"]?.formControlKey] = false
                toEmptySectionState[element?.["PFInput"]?.formControlKey] = ""
                toEmptyErrorState[element?.["PFInput"]?.formControlKey] = ""
            }
        });
        setSectionState(prev => {
            return {
                ...prev,
                sectionData: {
                    ...prev.sectionData,
                    ...toEmptySectionState,
                    ["totalFundValue"]: 0
                }
            }
        })
        setErrorState(prev => {
            return {
                ...prev,
                ...toEmptyErrorState
            }
        })
        setTotalError("")
        setShowLocalError(false)
    }

    const handleTotalPercentageCalculation = () => {
        let total = 0
        portfolioComponentsToShow?.forEach(element => {
            if (sectionState.sectionData && sectionState.sectionData[element?.["PFInput"]?.formControlKey]) {
                total = total + parseInt(sectionState.sectionData[element?.["PFInput"]?.formControlKey])
            }
        })
        if (total > 100) {
            setTotalError("Total allocation percentage cannot be greater than 100%")
            setShowLocalError(true)
        } else (
            setTotalError("")
        )
        setSectionState(prev => {
            return {
                ...prev,
                sectionData: {
                    ...prev.sectionData,
                    ["totalFundValue"]: total
                },
            }
        })
    }

    const handleCheckboxPercentageDeletion = (percentageToRemove) => {
        let total = sectionState.sectionData?.["totalFundValue"]
        total = total - parseInt(percentageToRemove)
        setSectionState(prev => {
            return {
                ...prev,
                sectionData: {
                    ...prev.sectionData,
                    ["totalFundValue"]: total
                },
            }
        })
    }

    return (
        <>
            <style>
                {`
                .tatoal{
                    background-color: ${props =>
                        props.channel === "A"  || props.channel === "28" || props.channel === "35" || props.channel === "39"
                            ? "#3e505d"
                            : props.channel === "B"
                                ? "#a20a3a"
                                : props.channel === "C"
                                    ? "#0ab0ef"
                                    : "#eb7f25"};
                    background-color: var(--lumiq-card-bg);                 
                    padding: 10px;
                    color: #fff;
                    width: 66%;
                    float: left;
                    margin-right: 30px;
                }
                @media (max-width: 767px){
                    .tatoal {
                        margin-right: 0px;
                    }
                  }
                .tatoal100{
                    background-color: ${props =>
                        props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39"
                            ? "#3e505d"
                            : props.channel === "B"
                                ? "#a20a3a"
                                : props.channel === "C"
                                    ? "#0ab0ef"
                                    : "#eb7f25"};
                        background-color: var(--lumiq-card-bg); 
                    padding: 10px;
                    color: #fff;
                    width: 30%;
                    float: right;
                }

                .text-center{
                    text-align: center!important;
                }

                .fundline-new {
                    text-align: center !important;
                    display: block;
                    font-weight: 600;
                }
                .input[type=button]{
                    color:red !important;
                    font-size:12rem !important;
                }
                @media (max-width: 767px){
                    .mobile-view-btn-Q1 .submit-btn {
                        padding: 10px 7px;
                        margin: 5px 0px;
                        width: 110px;
                        line-height: 25px;
                    }
                
            ` }
            </style>
            <span>Here you can choose from a range of {portfolioLength} Unit Linked Funds. You can choose to allocate your Premiums to any, all or a combination of the Unit Linked Funds as per your risk preference.</span>
            <h2><b>Choose your Fund(s)</b></h2>
            <h5 className="col-lg-9 col-12 pr-30 pl-pr"><b>How you would like to allocate your investment across different Funds?*</b></h5>
            <h5 className="col-lg-3 col-12 pl-30 pl-pr  text-center allocate-right-head"><b>Allocation(%):</b></h5>
            {

                portfolioComponentsToShow?.map((element, i) => {
                    if (element['__typename'] === "ComponentCmpGrpPf") {
                        return (
                            <div className={`field ${element.class}`} key={props.sectionId + i}>
                                <ComponentFormPortfolioFields key={i} data={portfolioComponentsToShow[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} handleTotalPercentageCalculation={handleTotalPercentageCalculation} handleCheckboxPercentageDeletion={handleCheckboxPercentageDeletion} />
                            </div>

                        )
                    }
                    return (<></>)
                })
            }
            <div className="row">
                <div className="col-lg-12 col-12 col-sm-12 mt-10 pr pl">
                    <hr className="hr-line" />
                    <div className="tatoal">Total Allocation Percentage (%)</div>
                    <div className="tatoal100 text-center">{sectionState.sectionData?.["totalFundValue"] || 0}</div>
                    <span style={{ float: "right", width: "30%" }} className="input-error2">{showLocalError && totalError}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-12 col-sm-12 mt-10 pr">
                    <div className="but-center text-right" style={{ textAlign: "right" }}>
                        <div className="submit-btn cen" aria-hidden="true" style={{ padding: "14px 0px" }} onClick={handleReset}> <a> Reset</a> </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 pl-pr">
                    <hr className="hr-line" />
                    <div className="row inside-row">
                        <div className="col-lg-12 pr pl">
                            <label className="fundline-new">To view the past performance of the funds, <a href="https://www.canarahsbclife.com/funds-navs/fund-performance.html" target="_blank">Click Here</a></label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix"></div>
            <div className="iselect-mg-bottom pd40 hidden-desktop-screen">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="but-center text-right">
                            <div className="submit-btn cen" aria-hidden="true" onClick={handlePrevious}> <a >Previous </a> </div>
                            <input aria-hidden="true" onClick={handleProceed} className="previous-btn cen" style={{ color: "white", padding: "14px 40px", border: "none" }} type="button" value="Calculate Fund Value" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile view Buttons */}
            <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
                <div className="iselect-mg-bottom">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="but-center text-center">
                                <div className="submit-btn cen" aria-hidden="true" style={{ paddingLeft: "5px" }} onClick={handlePrevious}> <a >Previous </a> </div>
                                <input aria-hidden="true" onClick={handleProceed} className="previous-btn cen bi-btv" style={{ color: "white", padding: "14px 0px", border: "none", marginLeft: "10px", width: "160px" }} type="button" form="aDetail" align="right" value="Calculate Fund Value" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
